import React from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

export const EmotionCacheProvider = ({ children }: { children: React.ReactNode }) => {
  const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute("content");

  const cache = React.useMemo(
    () =>
      createCache({
        key: "overwritable",
        nonce: nonce || undefined,
        prepend: true,
        container: document.head,
      }),
    [nonce],
  );

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};
